import { render, staticRenderFns } from "./ApprovalConfigTable.vue?vue&type=template&id=4c781a3a&scoped=true"
import script from "./ApprovalConfigTable.vue?vue&type=script&lang=js"
export * from "./ApprovalConfigTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovalConfigTable.vue?vue&type=style&index=0&id=4c781a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c781a3a",
  null
  
)

export default component.exports